const projects = [
  {
    id: 1,
    title: "HFC",
    description: "Startup Based in Los Angeles",
    link: "https://homefromcollege.com/",
    github: "https://github.com/Home-From-College",
    image: "hfc.gif",
  },
  {
    id: 2,
    title: "Treetop Golf",
    description: "Mini Golf based in UK",
    link: "https://adventuregolf.com/",
    github: "https://github.com/Lukabaramishvili",
    image: "adv.png",
  },
  {
    id: 3,
    title: "Falafel.fm",
    description: "Online mixtape listening station, currated by me",
    link: "https://falafelfm.netlify.app/",
    github: "https://github.com/Lukabaramishvili/falafel.fm",
    image: "falafel.gif",
  },
  {
    id: 4,
    title: "Azymuth in Tbilisi",
    description:
      "Event banner Website for the concert that was organized by my company - Lyra Entertainment",
    link: "https://azymuth-tbilisi.netlify.app/",
    github: "https://github.com/Lukabaramishvili/Azymuth-in-Tbilisi",
    image: "azymuth.jpg",
  },
  {
    id: 5,
    title: "Fifty Festival",
    description: "Fifty Festival is 3 day made up music festival in CA.",
    link: "https://festival-l.netlify.app/",
    github: "https://github.com/Lukabaramishvili/Festival-L",
    image: "festival.gif",
  },
  {
    id: 6,
    title: "Memory Game",
    description: "Javascript Memory Game",
    link: "https://simplememory.netlify.app/",
    github: "https://github.com/Lukabaramishvili/memory-game",
    image: "memorygame.jpg",
  },
];

export default projects;
